import { ColorPickerInput } from "@/overlay/components/LayerStackWindow/LayerFormElements/ColorPickerInput";
import { Controller } from "react-hook-form";
import { useValueNameCreator } from "../../../SmartFormUtils/FormHooks/useFormInstructions";
import type { InputInstruction } from "../../../SmartFormUtils/commonTypeUtils";

type Props = {
  label: string;
  instruction: InputInstruction<string | undefined>;
  onValueCommit?: (nextColor: string) => void;
};

export function CartographicMaterialColorPicker({ label, instruction, onValueCommit }: Props) {
  const { formMethods, currValue } = instruction;
  const { createInputName } = useValueNameCreator<string>(instruction);
  const inputName = createInputName();
  const fallbackColor = currValue ?? "#000000";

  return (
    <Controller
      control={formMethods.control}
      name={inputName}
      defaultValue={fallbackColor}
      render={({ field }) => (
        <ColorPickerInput
          label={label}
          value={(field.value as string | undefined) ?? fallbackColor}
          change={(nextColor) => {
            field.onChange(nextColor);
            onValueCommit?.(nextColor);
          }}
          commitOnChangeComplete={Boolean(onValueCommit)}
          commitDebounceMs={180}
          formFieldOptions={{ noSemanticLinking: true }}
        />
      )}
    />
  );
}
